// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';

const MaintenancePlanModelCriteria = props =>
    <div className='maintenance-plan-model-criteria'>
        <LabeledCriteria
            className='model-criteria'
            isRequired={false}
            label='MODEL'
            maxLength='19'
            onInputChange={props.onHandleModelInputChange}
            placeholder='MODEL'
            type='text'
            value={props.model}
        />
    </div>;

MaintenancePlanModelCriteria.displayName = 'MaintenancePlanModelCriteria';
MaintenancePlanModelCriteria.propTypes = {
    model: PropTypes.string.isRequired,
    onHandleModelInputChange: PropTypes.func.isRequired
};

export default MaintenancePlanModelCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-model-criteria.js